module.exports = __webpack_public_path__ + "static/media/dispepsia.38b4484d.jpg";